import CallIcon from 'components/atoms/icons/callIcon';

const CallButton = () => (
  <div className="call-btn__content">
    <div className="call-btn__text">Call patient primary number</div>
    <div className="call-btn__icon">
      <CallIcon />
    </div>
  </div>
);

export default CallButton;
